import Axios from 'axios'

const instance = Axios.create()

instance.defaults.headers.common['Authorization'] = `Bearer ${window.localStorage.getItem('token')}`

export default instance
